// extracted by mini-css-extract-plugin
export default {"summary-container":"style_summary-container__+SU1n","summary-section-header":"style_summary-section-header__0kah7","edit-button":"style_edit-button__oBPqb"};